import { memo, useContext } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const InputTel = memo(({ label, require }) => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);
	const telPattern = /^0[-0-9]{9,12}$/;

	const onChange = (e) => {
		setInputs({ ...inputs, tel: e.target.value });
		if (e.target.value.length > 0) {
			if (!telPattern.test(e.target.value)) {
				setErrors({
					...errors,
					tel: "*電話番号の形式が正しくありません",
				});
			} else {
				setErrors({ ...errors, tel: null });
			}
		} else if (require) {
			setErrors({ ...errors, tel: "*必須" });
		}
	};
	return (
		<label className={styles.labelCommon}>
			<p className="bold">
				{label}
				<span>{errors.tel}</span>
			</p>
			<input
				type="text"
				name="tel"
				value={inputs.tel}
				onChange={onChange}
				placeholder="0120351710"
			/>
		</label>
	);
});

export default InputTel;
